export const validateMandatory = (value: string | number | null | undefined) : string | null | undefined => {
    return !value ? "Ce champ est obligatoire" : null;
}